import React from 'react';
import flexieLogo from '../../assets/flexie-logo.png';

interface LogoProps {
  className?: string;
  showCompanyName?: boolean;
  variant?: 'default' | 'modern' | 'compact';
}

const Logo: React.FC<LogoProps> = ({ 
  className, 
  showCompanyName = false, 
  variant = 'modern' 
}) => {
  if (variant === 'modern') {
    return (
      <div className="flex flex-col items-center">
        <div className="flex items-center justify-center">
          <img 
            src={flexieLogo} 
            alt="Flexie CRM Logo" 
            className={`${className} transition-all duration-300`} 
          />
        </div>
      </div>
    );
  }
  
  if (variant === 'compact') {
    return (
      <div className="flex items-center space-x-2">
        <img 
          src={flexieLogo} 
          alt="Flexie CRM Logo" 
          className={`${className} max-h-8`} 
        />
      </div>
    );
  }
  
  // Default variant
  return (
    <div className="flex flex-col items-center pt-1">
      <img 
        src={flexieLogo} 
        alt="Flexie CRM Logo" 
        className={className} 
      />
    </div>
  );
};

export default Logo; 